import axios from "axios";
import urls from "../global/constants/UrlConstants";
import { store } from "./store";
import { addIdemp } from "../redux/menuSlice";
import notifiers from "../global/constants/NotificationConstants";

export const api = axios.create({
  baseURL: urls.url,
  validateStatus: function (status) {
    // Accept status codes 200-299 and 302
    return (status >= 200 && status < 300) || status === 302;
  },
});

api.interceptors.request.use(
  async (request: any) => {
    if (!urls.idempEndpoints.includes(request.url ?? "")) {
      return request;
    }
    const idemp = store.getState().menu.idemp;
    const idempotencyKey = idemp?.key ?? "";
    request.headers["idempotency-key"] = idempotencyKey;
    return request;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: any) => {
    if (response.request.responseURL.includes(urls.SPLITPAYCHECKOUT)) {
      store.dispatch(
        addIdemp({
          mode: "pay",
          key: "",
          hash: "",
        })
      );
    }
    return response;
  },
  (error: any) => {
    throw error;
  }
);
